import { render, staticRenderFns } from "./SiteDescription.vue?vue&type=template&id=46403fba&"
import script from "./SiteDescription.vue?vue&type=script&lang=js&"
export * from "./SiteDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports